module.exports = __webpack_public_path__ + "media/images/course_section_3-83f5a00e4f1539aa7a74531366cd1587.png";